import SensorShowPage from './sensor-show-page';

export default SensorShowPage;